module.exports = __webpack_public_path__ + "static/media/bg.074ea613.png";